import * as Lang_term_bs$SolvuuApi0 from "./lang_term_bs.bs.js";
var Json =
/* alias */
0;
var json_of_fmt0 = Lang_term_bs$SolvuuApi0.write_fmt0;
var json_of_lang_term = Lang_term_bs$SolvuuApi0.write_lang_term;
var json_of_blob_id = Lang_term_bs$SolvuuApi0.write_blob_id;
var json_of_job_id = Lang_term_bs$SolvuuApi0.write_job_id;
var json_of_label = Lang_term_bs$SolvuuApi0.write_label;
var json_of_term_id = Lang_term_bs$SolvuuApi0.write_term_id;
var json_of_type0 = Lang_term_bs$SolvuuApi0.write_type0;
var json_of_var = Lang_term_bs$SolvuuApi0.write_var;
var json_of_lang_term_future = Lang_term_bs$SolvuuApi0.write_lang_term_future;
var json_of_lang_term_error = Lang_term_bs$SolvuuApi0.write_lang_term_error;
var json_of_future = Lang_term_bs$SolvuuApi0.write_future;
var json_of_error = Lang_term_bs$SolvuuApi0.write_error;
var json_of_date = Lang_term_bs$SolvuuApi0.write_date;
var json_of_time = Lang_term_bs$SolvuuApi0.write_time;
var json_of_env = Lang_term_bs$SolvuuApi0.write_env;
var json_of_intrinsic = Lang_term_bs$SolvuuApi0.write_intrinsic;
var json_of_meta = Lang_term_bs$SolvuuApi0.write_meta;
var json_of_item = Lang_term_bs$SolvuuApi0.write_item;
var json_of_map = Lang_term_bs$SolvuuApi0.write_map;
var json_of_dir = Lang_term_bs$SolvuuApi0.write_dir;
var json_of_t = Lang_term_bs$SolvuuApi0.write_t;
var fmt0_of_json = Lang_term_bs$SolvuuApi0.read_fmt0;
var lang_term_of_json = Lang_term_bs$SolvuuApi0.read_lang_term;
var blob_id_of_json = Lang_term_bs$SolvuuApi0.read_blob_id;
var job_id_of_json = Lang_term_bs$SolvuuApi0.read_job_id;
var label_of_json = Lang_term_bs$SolvuuApi0.read_label;
var term_id_of_json = Lang_term_bs$SolvuuApi0.read_term_id;
var type0_of_json = Lang_term_bs$SolvuuApi0.read_type0;
var var_of_json = Lang_term_bs$SolvuuApi0.read_var;
var lang_term_future_of_json = Lang_term_bs$SolvuuApi0.read_lang_term_future;
var lang_term_error_of_json = Lang_term_bs$SolvuuApi0.read_lang_term_error;
var future_of_json = Lang_term_bs$SolvuuApi0.read_future;
var error_of_json = Lang_term_bs$SolvuuApi0.read_error;
var date_of_json = Lang_term_bs$SolvuuApi0.read_date;
var time_of_json = Lang_term_bs$SolvuuApi0.read_time;
var env_of_json = Lang_term_bs$SolvuuApi0.read_env;
var intrinsic_of_json = Lang_term_bs$SolvuuApi0.read_intrinsic;
var meta_of_json = Lang_term_bs$SolvuuApi0.read_meta;
var item_of_json = Lang_term_bs$SolvuuApi0.read_item;
var map_of_json = Lang_term_bs$SolvuuApi0.read_map;
var dir_of_json = Lang_term_bs$SolvuuApi0.read_dir;
var t_of_json = Lang_term_bs$SolvuuApi0.read_t;
export { Json, json_of_fmt0, json_of_lang_term, json_of_blob_id, json_of_job_id, json_of_label, json_of_term_id, json_of_type0, json_of_var, json_of_lang_term_future, json_of_lang_term_error, json_of_future, json_of_error, json_of_date, json_of_time, json_of_env, json_of_intrinsic, json_of_meta, json_of_item, json_of_map, json_of_dir, json_of_t, fmt0_of_json, lang_term_of_json, blob_id_of_json, job_id_of_json, label_of_json, term_id_of_json, type0_of_json, var_of_json, lang_term_future_of_json, lang_term_error_of_json, future_of_json, error_of_json, date_of_json, time_of_json, env_of_json, intrinsic_of_json, meta_of_json, item_of_json, map_of_json, dir_of_json, t_of_json };
/* Lang_term_bs-SolvuuApi0 Not a pure module */